import { SimpleIndexPage } from 'modules/billing/components/SimpleIndexPage/SimpleIndexPage';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalContextProvider, useModalContext } from 'utils/contexts/modal';
import { fetchApiKeyTypesRequest, fetchApiKeysRequest } from '../actions';
import { getApiKeys, isFetchingApiKeys } from '../selectors';
import { queryByFn } from '../utils';
import { MODAL_ACTION, ModalState } from './ApiKeyModal.constants';
import { CreateApiKeyModal } from './CreateApiKeyModal';
import { DeleteApiKeyModal } from './DeleteApiKeyModal';
import { DisableApiKeyModal } from './DisableApiKeyModal';
import { EditApiKeyModal } from './EditApiKeyModal';
import { columns, createRows } from './ApiKeysPage.utils';
import { PageActions } from './PageActions';
import { TableActions } from './TableActions';
import { createRowCell } from './TableCell';
import { ViewApiKeyModal } from './ViewApiKeyModal';

export const TEXT = {
  pageHeader: 'API Keys',
};

const ApiKeys = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isFetchingApiKeys);

  useEffect(() => {
    dispatch(fetchApiKeysRequest());
    dispatch(fetchApiKeyTypesRequest());
  }, []);

  const { modalState } = useModalContext<ModalState>();
  const { keys = [] } = useSelector(getApiKeys);
  const keyRows = createRows(keys);

  return (
    <div id="api-keys-page">
      <SimpleIndexPage
        pageTitle={TEXT.pageHeader}
        columns={columns}
        rows={keyRows}
        isLoading={isLoading}
        createRowCell={createRowCell}
        pageActions={<PageActions />}
        TableActions={TableActions}
        queryByFn={queryByFn}
        pluralResourceName="API keys"
        numLoadingRows={3}
      />

      {modalState?.action === MODAL_ACTION.CREATE_API_KEY && <CreateApiKeyModal />}
      {modalState?.action === MODAL_ACTION.EDIT_API_KEY && <EditApiKeyModal />}
      {modalState?.action === MODAL_ACTION.DELETE_API_KEY && <DeleteApiKeyModal />}
      {modalState?.action === MODAL_ACTION.DISABLE_API_KEY && <DisableApiKeyModal />}
      {modalState?.action === MODAL_ACTION.VIEW_API_KEY && <ViewApiKeyModal />}
    </div>
  );
};

export const ApiKeysPage = () => (
  <ModalContextProvider>
    <ApiKeys />
  </ModalContextProvider>
);
